// Make sure bootstrap css is before app, otherwise it's hard to get app styles to take precedence.
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import { Auth0Plugin } from './auth'
import Toasted from 'vue-toasted'

import store from './store'

import axios from 'axios'

import moment from 'moment'

import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import PhoneNumber from 'awesome-phonenumber'

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
// eslint-disable-next-line camelcase
import { required, email, image, is, ext, length, min_value } from 'vee-validate/dist/rules'

import { domain, clientId, audience } from '../auth_config.json'
import Multiselect from 'vue-multiselect'

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    )
  }
})

const phoneNumber = {
  getMessage: field => `${field} is not a valid phone number`,
  validate (value) {
    return new Promise(resolve => {
      let phone = new PhoneNumber(value, 'US')
      resolve({ valid: phone.isValid() })
    })
  }
}

extend('required', required)
extend('email', email)
extend('phoneNumber', phoneNumber)
extend('image', image)
extend('is', is)
extend('ext', ext)
extend('length', length)
extend('min_value', min_value)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('multiselect', Multiselect)
Vue.use(router)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Toasted)

Vue.config.productionTip = false

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment.utc(String(value)).format('MM/DD/YYYY hh:mm a')
  }
})

Vue.filter('formatDateAsMonth', function (value) {
  if (value) {
    return moment.utc(String(value)).format('MMM YYYY')
  }
})

Vue.filter('formatDateNoTime', function (value) {
  if (value) {
    return moment.utc(String(value)).format('MM/DD/YYYY')
  }
})

Vue.filter('formatDateWithDayName', function (value) {
  if (value) {
    return moment.utc(String(value)).format('ddd, MMM Do')
  }
})

Vue.filter('fullName', function (value) {
  let name = ''
  if (value && value.firstName) {
    name = value.firstName
    if (value.lastName) {
      name += ` ${value.lastName}`
    }
    return name
  }
})

Vue.filter('formatCurrency', function (value, forceDecimals = true) {
  if (value == null || value === '') return '$0'
  if (isNaN(value)) return value

  return Number(value).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: forceDecimals ? 2 : (value % 1 === 0 ? 0 : 2),
    maximumFractionDigits: 2
  })
})

Vue.directive('currency-input', {
  bind (el, binding) {
    // Add event listener
    el.addEventListener('input', (e) => {
      // Replace non-numeric characters, allowing for one decimal point
      const input = e.target.value.replace(/[^0-9.]/g, '').replace(/^[0]+/g, '')
      // Allow only one decimal point
      const parts = input.split('.')

      // if (input === 0 || input.startsWith('0')) {
      //   e.target.value = ''
      //   return
      // }
      // Limit decimal places to two
      if (parts[1] && parts[1].length > 2) {
        parts[0] = parts[0].toString() + parts[1].slice(0, 1)
        parts[1] = parts[1].slice(1, 3)
      }

      const formattedValue = input === '' ? '' : `$${parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
      e.target.value = input.includes('.') ? `${formattedValue}.${parts[1]}` : `${formattedValue}`
    })
  }
})

axios.interceptors.request.use(async (config) => {
  try {
    const token = await Vue.prototype.$auth.getTokenSilently()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  } catch (e) {
    // Unauthenticated (e.g. public share page in incognito) — no token needed
  }
  config.baseURL = process.env.API_URL
  config.headers['common'] = {}
  return config
})

axios.interceptors.response.use(
  response => response,
  error => {
    if (!error.response) {
      // Network error or API is down
      Vue.prototype.$toasted.error('Unable to connect to the server. Please check your internet connection or try again later.', {
        duration: 5000,
        position: 'top-center'
      });
    } else if (error.response.status === 500) {
      // Server error
      Vue.prototype.$toasted.error('The server encountered an error. Please try again later.', {
        duration: 5000,
        position: 'top-center'
      });
    } else if (error.response.status === 401) {
      // Unauthorized - handled by auth system
      console.log('Unauthorized request');
    } else if (error.response.status === 403) {
      // Forbidden
      Vue.prototype.$toasted.error('You do not have permission to perform this action.', {
        duration: 5000,
        position: 'top-center'
      });
    } else if (error.response.status === 404) {
      // Suppress toast for export-job polling — those 404s are handled silently by pollJobStatus.
      const url = error.config && error.config.url || ''
      const isJobPoll = url.includes('/importexport/jobs')
      if (!isJobPoll) {
        Vue.prototype.$toasted.error('The requested resource was not found.', {
          duration: 5000,
          position: 'top-center'
        });
      }
    }
    return Promise.reject(error);
  }
);

// VeeValidate.Validator.extend('phoneNumber', phoneNumber)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
